import { Expose, plainToClass } from "class-transformer";

export enum TripTier {
  COMPLETE = "complete",
  ESSENTIAL = "essential",
}

export interface ITrip {
  id: number;
  uuid: string;
  tier: TripTier;

  startOn: string;
  endOn: string;

  brandName: string | null;
  coveredPassengersQuantity: number;

  upgradeable: boolean;
}

export class Trip implements ITrip {
  @Expose() id: number;

  @Expose() uuid: string;
  @Expose() tier: TripTier;

  @Expose() startOn: string;
  @Expose() endOn: string;

  @Expose() brandName: string | null;
  @Expose() coveredPassengersQuantity: number;

  @Expose() upgradeable: boolean;
}

export function transformToTripClass(trip: ITrip): Trip {
  return plainToClass(Trip, trip);
}
